import { useCallback } from "react";
import { useAdminAccessStore } from "../stores/adminAccessStore";

/** Capabilities are supplied by the server; UI visibility is never authorization. */
export function useAdminAccess() {
  const authUid = useAdminAccessStore((state) => state.authUid);
  const role = useAdminAccessStore((state) => state.role);
  const permissions = useAdminAccessStore((state) => state.permissions);
  const loading = useAdminAccessStore((state) => state.loading);
  const can = useCallback((permission: string) => permissions.includes(permission), [permissions]);
  return { authUid, role, loading, can };
}
